import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../api-services/Auth/auth.service';
import { keyService } from '../api-services/keycloak/service/key.service';
/**
 * In this component to verify the member activation link id.
 * If link id valid to show activation message else navigate to login page.
 */
@Component({
  selector: 'app-member-active-account',
  templateUrl: './member-active-account.component.html',
  styleUrls: ['./member-active-account.component.css']
})
export class MemberActiveAccountComponent implements OnInit {

  constructor(private router: Router, private activation: AuthService,private activatedRouter: ActivatedRoute,
    private key_service:keyService) { }
  accId:any;
  message:any;
  confirmStatus:boolean =true;
  ngOnInit(): void {
    this.accId = this.activatedRouter.snapshot.params['activationId'];
    this.memberActiveAccount();
  }
  memberActiveAccount(){
    let req ={
      activationLink:this.accId
    }
    this.activation.memberActivation(req).subscribe((res:any) =>{      
      if(res.status){
        this.message =res.message;   
      }else{
        this.router.navigate(['/login'],{queryParams:{redirectTo:''}});
      }
      
    },(err)=>{

       this.confirmStatus =false
    })
  }
}
